import { type PropsWithChildren } from 'react'
import TransfereFacilIcon from '@/assets/icons/trasnfere-facil-icon'
import { ManagerSession } from '@/components/user/user-session'
import { LoadingWrapper } from '@/components/wrappers/loading-wrapper'
import { ROLES } from '@/constants/roles'
import { useAuthStore } from '@/store/auth-store'

interface PageLayoutProps extends PropsWithChildren {
  isLoading?: boolean
  loadingText?: string
  disabledSessionComponent?: boolean
  onlyFirstLoad?: boolean
}

export const PageLayout = ({
  children,
  isLoading,
  disabledSessionComponent,
  loadingText,
  onlyFirstLoad
}: PageLayoutProps) => {
  const { userName, role } = useAuthStore()

  const renderSessionComponent = () => {
    if (!disabledSessionComponent) {
      if (role === ROLES.MANAGER.id) {
        return <ManagerSession name={userName} />
      }
    }
    return
  }

  function renderPage() {
    return (
      <LoadingWrapper
        className="h-[calc(100vh-160px)]"
        isLoading={isLoading}
        text={loadingText}
        onlyFirstLoad={onlyFirstLoad}
      >
        {children}
      </LoadingWrapper>
    )
  }

  return (
    <div className="w-full h-full">
      <div className="bg-[var(--brand-blue-3)] flex items-center justify-between h-20 px-12">
        <div className="flex gap-3 items-center">
          <TransfereFacilIcon className="h-10" />
          <p className={'text-background font-bold text-2xl'}>
            Transfere fácil
          </p>
        </div>
        <div>{renderSessionComponent()}</div>
      </div>
      {renderPage()}
    </div>
  )
}
